export enum WithdrawalMethodId {
  CardPersonal = 2,
  Paypal = 4,
  ADVCash = 6,
  CODEOffice = 7,
  BankTransferPrivate = 9, // not current iteration
  BankTransferINR = 11,
  Crypto = '0', // zero as string for select option compatibility
}
export interface WithdrawalMethod {
  id: WithdrawalMethodId;
  key: string;
  currencies: string[];
  name: string; // fe prop
}

export const WITHDRAWAL_METHODS: WithdrawalMethod[] = [
  {
    id: WithdrawalMethodId.CardPersonal,
    key: 'withdrawal.methods.cardPersonal',
    currencies: ['USD', 'EUR', 'UAH', 'KZT', 'AZN'],
    name: 'cardPersonal',
  },
  {
    id: WithdrawalMethodId.Paypal,
    key: 'withdrawal.methods.paypal',
    currencies: ['USD', 'EUR', 'INR'],
    name: 'paypal',
  },
  {
    id: WithdrawalMethodId.ADVCash,
    key: 'withdrawal.methods.advcash',
    currencies: ['USD'],
    name: 'advcash',
  },
  {
    id: WithdrawalMethodId.BankTransferINR,
    key: 'withdrawal.methods.bankTransferINR',
    currencies: ['INR'],
    name: 'bankTransferINR',
  },
  {
    name: 'CODEOffice',
    id: WithdrawalMethodId.CODEOffice,
    key: 'withdrawal.methods.CODEOffice',
    currencies: ['USD', 'EUR', 'INR', 'KZT', 'UAH', 'AZN'],
  },
  {
    name: 'Crypto',
    id: WithdrawalMethodId.Crypto,
    key: 'withdrawal.methods.crypto',
    currencies: ['USDT', 'USDC', 'BTC'],
  },
  // not current iteration
  // {
  //   id: WithdrawalMethodApiId.BankTransferPrivate,
  //   name: 'withdrawal.methods.bankTransferPrivate',
  //   currencies: ['']
  // },
];

export const getWithdrawalMethodsByCurrency = (
  methods: WithdrawalMethod[],
  currency: string,
  disabledMethodsIds: WithdrawalMethodId[] = [],
): WithdrawalMethod[] => {
  return methods.filter(
    (method) =>
      method.currencies.includes(currency) &&
      !disabledMethodsIds.includes(method.id),
  );
};
